import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);


export class ErrorList {
	#errors = [];

	clear(path, code) {
		this.add(path, null, code);
	}

	add(path, error, code) {
		if (!error || typeof error === 'string') {
			error = {
				type: 'error',
				message: error,
				code: code || '_'
			};
		} else if (!error.code) {
			error = Object.assign({}, error);
			error.code = code || '_';
		}
		this.#errors.push({
			path,
			error: Immutable.Map(error)
		});
	}

	dump() {
		console.log('errorList', this.#errors);
	}

	getCount() {
		return this.#errors.length;
	}

	mergeWith(map) {
		this.#errors.forEach(errorEntry => {
			const path = errorEntry.path;
			const error = errorEntry.error;
			let errorsAtPath = map.getIn(path);
			if (errorsAtPath) {
				const code = error.get('code');
				errorsAtPath = errorsAtPath.filter(eap => eap.get('code') !== code);
				if (error.get('message')) {
					errorsAtPath = errorsAtPath.push(error);
				}
				map = map.setIn(path, errorsAtPath);
			} else if (error.get('message')) {
				map = map.setIn(path, Immutable.List([error]));
			}
		});
		return map;
	}

	toMap() {
		let errorEntries = this.#errors.filter(e => e.error.get('message'));
		let map = EMPTY_MAP;
		errorEntries.forEach(errorEntry => {
			const path = errorEntry.path;
			const error = errorEntry.error;
			const errorsAtPath = (map.getIn(path) || EMPTY_LIST).push(error);
			map = map.setIn(path, errorsAtPath);
		});
		return map;
	}

	getErrorEntries() {
		let errorEntries = this.#errors.filter(e => e.error.get('message')).map(e => Immutable.Map(e));
		return Immutable.List(errorEntries);
	}

}

export function getErrorType(errors) {
	if (typeof errors === 'string') {
		return 'error';
	}
	if (!errors || errors.size === 0) {
		return null;
	}
	return errors.some(e => e.get('type') === 'error') ? 'error' : 'warning';
}

export function getErrorMessages(errors) {
	if (typeof errors === 'string') {
		return Immutable.List([errors]);
	}
	if (!errors || errors.size === 0) {
		return null;
	}
	return errors.map(e => e.get('message'));
}

export function isEmpty(value) {
	if (typeof value === 'string') {
		return value.trim() === '';
	} else if (Immutable.isList(value)) {
		return value.size === 0;
	} else if (Array.isArray(value)) {
		return value.length === 0;
	} else if (Immutable.isMap(value)) {
		const type = value.get('type');
		if (type.endsWith('Range')) {
			const from = value.get('from');
			const to = value.get('to');
			const fromEmpty = from === undefined || from === null;
			const toEmpty = to === undefined || to === null;
			return fromEmpty && toEmpty;
		}
	} else {
		return value === null || value === undefined;
	}
}

export function ValueValidator(func) {
	if (!(this instanceof ValueValidator)) {
		return new ValueValidator(func)
	}

	this.isValueValidator = true;

	this.validate = function(value) {
		return func(value);
	};
}

export function ContextValidator(func) {
	if (!(this instanceof ContextValidator)) {
		return new ContextValidator(func)
	}

	this.isContextValidator = true;

	this.validate = function(errorList, ctx, itemName) {
		return func(errorList, ctx, itemName);
	};
}

